// Module
var code = `<div appHeaderBar>
    <header-bar-title>Search for a Property Pay Profile</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <div class="search-sso-profile__back">
        <button type="button" class="search-sso-profile__back-link" tid="backLink" (click)="goBack()">
            <span aria-hidden="true">&larr;</span> Return to Previous
        </button>
    </div>

    <div class="HOA-container">
        <div class="HOA-container__header">
            <div class="search-sso-profile__heading">
                <h1 class="HOA-container__header-text" tid="searchHeader">Search for a Property Pay Profile</h1>
                <p class="search-sso-profile__sub-header" tid="searchSubHeader">
                    Search for an existing profile by email or phone number
                </p>
            </div>
        </div>

        <div class="HOA-container__content">
            <form [formGroup]="form" (ngSubmit)="search()">
                <label class="Field-label search-sso-profile__label" for="searchText">Email or Phone Number</label>

                <div class="search-sso-profile__row">
                    <div class="Field search-sso-profile__field" [class.is-invalid]="showError()">
                        <input
                                type="text"
                                class="Input search-sso-profile__input"
                                id="searchText"
                                tid="searchTextInput"
                                formControlName="searchText"
                                placeholder="e.g. name@example.com or (555) 123-4567"
                                maxlength="64"
                                autocapitalize="off"
                                autocomplete="off"
                                autocorrect="off"
                                spellcheck="false"
                                (blur)="formatOnBlur()"
                                [attr.aria-invalid]="showError()"
                        />
                        <span class="Field-error" tid="searchTextError">
              Please enter a valid email or phone number.
            </span>
                    </div>
                    <button
                            type="submit"
                            class="HOA-splash-buttons-container__button Button Button--blue"
                            tid="searchButton"
                            [disabled]="form.invalid || searching"
                    >
                        Search
                    </button>
                </div>

                <p *ngIf="!searched && !searching" class="search-sso-profile__hint">We will search for matching profile</p>
            </form>

            <div
                    *ngIf="searching" class="search-sso-profile__loading" tid="searchLoading" role="status" aria-live="polite"
            >
                <hr class="search-sso-profile__divider" />
                <div class="search-sso-profile__loading-row">
                    <span class="search-sso-profile__spinner" aria-hidden="true"></span>
                    <span>Searching&hellip;</span>
                </div>
            </div>

            <div *ngIf="searched" class="search-sso-profile__results" tid="searchResults">
                <hr class="search-sso-profile__divider" />
                <!-- Results found: heading + context line + the list -->
                <ng-container *ngIf="results.length; else noResults">
                    <label class="Field-label search-sso-profile__results-heading">Search Results</label>
                    <p class="search-sso-profile__results-for">Showing results for {{ query }}</p>

                    <div *ngFor="let profile of results" class="search-sso-profile__result" tid="searchResult">
                        <span class="search-sso-profile__result-email">{{ profile.email }}</span>
                        <button
                                type="button"
                                class="Button Button--outline"
                                (click)="selectProfile(profile)"
                        >
                            Select
                        </button>
                    </div>
                </ng-container>

                <!-- No results: single clear message + an actionable hint -->
                <ng-template #noResults>
                    <p class="search-sso-profile__no-results" tid="noResults">
                        No matching profiles found for {{ query }}.
                    </p>
                    <p class="search-sso-profile__no-results-hint">
                        Double-check the email or phone number and try again.
                    </p>
                </ng-template>
            </div>
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;